// GamePassDirect — countdown réel. Deadline et heure serveur viennent du HTML (data-*), pas de l'horloge du client.
import { prefersReducedMotion } from './vyrl.js';

const pad = (n) => String(n).padStart(2, '0');

const KEY = 'vyrl_cd_deadline_v1';

// localStorage, puis sessionStorage ; null si aucun n'est utilisable (navigation privée stricte).
function store() {
  for (const kind of ['localStorage', 'sessionStorage']) {
    try {
      const s = window[kind];
      s.setItem('vyrl_cd_t', '1');
      s.removeItem('vyrl_cd_t');
      return s;
    } catch (e) { /* suivant */ }
  }
  return null;
}

// Compteur PAR VISITEUR : l'échéance vit uniquement dans ce navigateur, posée à la 1re visite.
function initEvergreen(bar) {
  const span = Number(bar.dataset.hours) * 3600 * 1000;
  const reset = bar.dataset.onExpiry !== 'hide';
  const timer = bar.querySelector('[data-timer]');
  const st = store();
  if (!st || !(span > 0)) { bar.hidden = true; return; } // pas de stockage = pas de faux compteur

  const read = () => {
    const v = Number(st.getItem(KEY));
    // absente, corrompue ou incohérente (au-delà de la durée max) : ignorée
    return Number.isFinite(v) && v > 0 && v <= Date.now() + span ? v : 0;
  };
  const write = (v) => { try { st.setItem(KEY, String(v)); } catch (e) { /* ignoré */ } };

  let deadline = read();
  if (!deadline) { deadline = Date.now() + span; write(deadline); }
  const reduce = prefersReducedMotion();
  let lastMinute = null;
  let id;

  const tick = () => {
    let left = Math.floor((deadline - Date.now()) / 1000);
    if (left <= 0) {
      if (!reset) { clearInterval(id); bar.hidden = true; return; }
      deadline = Date.now() + span;
      write(deadline);
      left = Math.floor(span / 1000);
    }
    const d = Math.floor(left / 86400);
    const h = Math.floor((left % 86400) / 3600);
    const m = Math.floor((left % 3600) / 60);
    const s = left % 60;
    timer.innerHTML = `${d > 0 ? `<span>${d}j</span> ` : ''}<span>${pad(h)}</span>:<span>${pad(m)}</span>:<span>${pad(s)}</span>`;
    bar.classList.remove('vyrl-countdown--pending');
    if (!reduce && lastMinute !== null && m !== lastMinute) {
      bar.classList.remove('is-pulse');
      requestAnimationFrame(() => bar.classList.add('is-pulse'));
    }
    lastMinute = m;
  };

  tick();
  id = setInterval(tick, 1000);
}

function init(bar) {
  if (bar.dataset.ready) return;
  bar.dataset.ready = '1';
  if ('evergreen' in bar.dataset) return initEvergreen(bar);

  const deadline = Number(bar.dataset.deadline) * 1000;
  const offset = Number(bar.dataset.now) * 1000 - Date.now(); // corrige une horloge client fausse
  const timer = bar.querySelector('[data-timer]');
  const label = bar.querySelector('[data-label]');
  const reduce = prefersReducedMotion();
  let lastMinute = null;
  let id;

  const finish = () => {
    clearInterval(id);
    if (bar.dataset.expiredMode === 'message') {
      timer?.remove();
      if (label) label.textContent = bar.dataset.expiredLabel;
      bar.classList.add('vyrl-countdown--expired');
    } else {
      bar.hidden = true;
    }
  };

  const tick = () => {
    const left = Math.max(0, Math.floor((deadline - (Date.now() + offset)) / 1000));
    if (left === 0) return finish();
    const d = Math.floor(left / 86400);
    const h = Math.floor((left % 86400) / 3600);
    const m = Math.floor((left % 3600) / 60);
    const s = left % 60;
    timer.innerHTML = `${d > 0 ? `<span>${d}j</span> ` : ''}<span>${pad(h)}</span>:<span>${pad(m)}</span>:<span>${pad(s)}</span>`;
    if (!reduce && lastMinute !== null && m !== lastMinute) {
      bar.classList.remove('is-pulse');
      requestAnimationFrame(() => bar.classList.add('is-pulse')); // relance l'anim sans reflow forcé
    }
    lastMinute = m;
  };

  tick();
  id = setInterval(tick, 1000);
}

const start = () => document.querySelectorAll('[data-vyrl-countdown][data-deadline], [data-vyrl-countdown][data-evergreen]').forEach(init);
start();
document.addEventListener('shopify:section:load', start);
